import React, { memo, useEffect, useState } from "react";
import Modal from "styled-react-modal";

const StyledModal = Modal.styled`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => props.opacity};
  transition : all 0.3s ease-in-out;
`;

function CustomModal({ show, setShow, ...props }) {
	const [isOpen, setIsOpen] = useState(show);
	const [opacity, setOpacity] = useState(0);
	const toggleModal = () => setShow(!show);
	useEffect(() => {
		setOpacity(0);
		setIsOpen(show);
	}, [show]);

	function afterOpen() {
		setTimeout(() => {
			setOpacity(1);
		}, 100);
	}

	function beforeClose() {
		return new Promise((resolve) => {
			setOpacity(0);
			setTimeout(resolve, 300);
		});
	}

	return (
		<div>
			<StyledModal isOpen={isOpen} afterOpen={afterOpen} beforeClose={beforeClose} opacity={opacity} backgroundProps={{ opacity }} onBackgroundClick={toggleModal} onEscapeKeydown={toggleModal}>
				{props.children}
			</StyledModal>
		</div>
	);
}

export default memo(CustomModal);
